<template>
  <div id="licitacion-toolbar-licitacion">
    <titulo-tool-bar-base
      :titulo="titulo"
      :regresar="mostrarBtnRegresar">
      <template v-slot:opciones-derecha>
        <custom-button
          v-if="mostrarBotonPlantillas"
          label="Plantillas"
          iconText="mdi-file-word-outline"
          tipo="agregar"
          @click="generarNuevaPlantilla">
        </custom-button>
      </template>
    </titulo-tool-bar-base>
    <v-dialog
      v-model="mostrarGenerarNuevaPlantilla"
      scrollable
      persistent
      width="800">
      <generar-nueva-plantilla
        modulo="licitaciones"
        :datos="getDatos"
        :idarchivo="titulo"
        ref="generarNuevaPlantilla"
        @cerrarGenerarNuevaPlantilla="cerrarGenerarNuevaPlantilla">
      </generar-nueva-plantilla>
    </v-dialog>
  </div>
</template>

<script>
import TituloToolBarBase from '@/components/TituloToolBar.vue';
import CustomButton from '@/components/buttons/Button.vue';
import GenerarNuevaPlantilla from '@/components/administracion/configuracion/plantillas/generador/Default.vue';
import mixDatosLicitaciones from '@/components/administracion/configuracion/plantillas/generador/mixDatosLicitaciones';

export default {
  name: 'TituloToolBarLicitacion',
  props: {
    titulo: {
      type: String,
      required: false,
      default: '# Licitacion',
    },
    datos: {
      type: Object,
      required: false,
      default() { return {}; },
    },

    mostrarBtnRegresar: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    TituloToolBarBase,
    CustomButton,
    GenerarNuevaPlantilla,
  },
  mixins: [mixDatosLicitaciones],
  data() {
    return {
      mostrarGenerarNuevaPlantilla: false,
      mostrarBotonPlantillas: true,
    };
  },
  methods: {
    generarNuevaPlantilla() {
      this.mostrarGenerarNuevaPlantilla = !this.mostrarGenerarNuevaPlantilla;
    },
    cerrarGenerarNuevaPlantilla() {
      this.generarNuevaPlantilla();
    },
  },
  computed: {
    getDatos() {
      if (!this.datos) return {};
      return this.formatoWordLicitacion(this.datos);
    },
  },
};
</script>

<style lang="scss">

</style>
